import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'

const isSkipHome = () => {
  return localStorage.getItem(ELocalStorageKey.SKIP_HOME)
}

export default isSkipHome
